import { FC } from 'react';
import { useTranslate } from 'hooks/useTranslate';

type Props = {
  value: string;
  onChange: any;
};

const PersonalDataViewPhoneNr: FC<Props> = ({ value, onChange }) => {
  const { t } = useTranslate();

  return (
    <div className="col-md-6">
      <div className="form-group">
        <label className="form-label w-100" htmlFor="partner-phone">
          {t('Telephone')}
        </label>

        <input
          id="partner-phone"
          type="tel"
          className="form-control form-control-lg text-nowrap overflow-hidden text-truncate"
          value={value}
          onChange={onChange}
          placeholder={t('IntroducePhoneNumber')}
        />
      </div>
    </div>
  );
};

export default PersonalDataViewPhoneNr;
